import * as React from "react";
import { Input } from "./input";

const fmt = (v) => {
  const s = String(v ?? "").replace(/\D/g, "");
  return s ? s.replace(/\B(?=(\d{3})+(?!\d))/g, ".") : "";
};

export const MoneyInput = React.forwardRef(({ value, onChange, className = "", ...props }, ref) => (
  <div className="relative">
    <span className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-xs font-semibold text-slate-400">Rp</span>
    <Input
      ref={ref}
      type="text"
      inputMode="numeric"
      autoComplete="off"
      className={`font-mono pl-9 ${className}`}
      value={fmt(value)}
      onChange={(e) => onChange(e.target.value.replace(/\D/g, ""))}
      {...props}
    />
  </div>
));
MoneyInput.displayName = "MoneyInput";
